export const OtherChargesdata = {
  columns: [
    { id: "CHARGETYPE", label: "CHARGE TYPE", width: 70, textAlign: "left" },
    {
      id: "CHARGEFOR",
      label: "CHARGE FOR",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
      valueGetter: (params) => {
        const valueMap = {
          G: "Gross",
          N: "Nett",
        };
        return valueMap[params.row.CHARGEFOR] || params.row.CHARGEFOR;
      },
    },

    {
      id: "CHARGERATE",
      label: "CHARGE RATE (%)",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [],
  name: "Other Charges",
};

export const catergorydata = {
  columns: [
    {
      id: "MENUCATNAME",
      label: "Category NAME",
      width: 10,
      textAlign: "left",
    },
    // { id: 'COLORCODE', label: 'COLORCODE', width: 200,textAlign: "center",  backgroundColor: "COLORCODE", },
  ],
  rows: [],
  name: "Categories",
};

export const pcatergorydata = {
  columns: [
    {
      id: "MENUCATNAME",
      label: "Category NAME",
      width: 10,
      textAlign: "left",
    },
    // { id: 'COLORCODE', label: 'COLORCODE', width: 200,textAlign: "center",  backgroundColor: "COLORCODE", },
  ],
  rows: [],
  name: "Promotional Menu Category",
};

export const Itemdata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70, flexDirection: "row" },
    // { id: "MENUCODE", label: "MENU CODE", width: 70, flexDirection: "row" },
    // {
    //   id: "MEASURINGUNIT",
    //   label: "MEASURING UNIT",
    //   width: 200,
    //   textAlign: "center",
    //   flexDirection: "row-reverse",
    // },
    // { id: 'MENUCODE', label: ' MENUCODE', width: 130,textAlign: "right",flexDirection: 'row-reverse' },
    {
      id: "DISCOUNT",
      label: "  DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "RATE",
      label: "RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [],

  name: " Items",
};

export const schedulegdata = {
  columns: [
    { id: "", label: "GUEST NAME", width: 40 },
    { id: "", label: "CONTACT NUMBER", width: 40, textAlign: "CENTER" },
    { id: "", label: "DATE", width: 40, textAlign: "CENTER" },
    { id: "", label: "START TIME", width: 40, textAlign: "CENTER" },
    { id: "", label: "END TIME", width: 40, textAlign: "CENTER" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Schedule Details",
};

export const Receiptdata = {
  columns: [
    { id: "HEADER", label: "HEADER", width: 70 },
    { id: "FOOTER", label: "FOOTER", width: 130 },

    { id: "REFPOLICY", label: "REFund POLICY", width: 200 },
    { id: "TERMS", label: "TERMS", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Receipt Details",
};

export const Waitersdata = {
  columns: [
    { id: "NAME", label: "NAME", width: 70 },

    // { id: "ENUSER", label: "ENUSER", width: 130, textAlign: "center" },
  ],
  rows: [],

  name: "Waiters Details",
};

export const Printersdata = {
  columns: [
    { id: "PRINTERNAME", label: "PRINTER NAME", width: 70, textAlign: "left" },
    // { id: "MENUTYPECODE", label: "MENUTYPECODE", width: 200, textAlign: "left" },

    { id: "PRINTERIP", label: "Printer IP", width: 200, textAlign: "left",discardformatting:true },
  ],

  name: "Printer Details",
};

export const Barcodedata = {
  columns: [],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Barcode",
};

export const ManageOrderdata = {
  columns: [
    { id: "id", label: "ID", width: 70 },
    { id: "name", label: "Name", width: 130 },
    { id: "catergory", label: "catergory", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Manage Order",
};

export const Orderlistdata = {
  columns: [
    { id: "INVNO", label: "ORDER CODE", width: 70, textAlign: "left" },
    {
      id: "STS",
      label: "Status",
      width: 200,
      flexDirection: "row-reverse",
      disableSort: true,
      textAlign: "center",
    },
    { id: "ORDERENDATE", label: "ORDER DATE", width: 130, textAlign: "center" },
    {
      id: "AMOUNT",
      label: "AMOUNT",
      width: 200,
      textAlign: "right",
    },
  ],
  name: "Order List",
};

export const OfficerManageOrderData = {
  columns: [
    { id: "id", label: "Item", width: 70 },
    { id: "qty", label: "Qty.", width: 130 },
    { id: "rate", label: "Rate", width: 200 },
    { id: "amount", label: "Amount", width: 200 },
  ],
  rows: [
    {
      id: 1,
      qty: "Charge 1",
      rate: "Description for charge 1",
      amount: "Description for charge 2",
    },
    {
      id: 2,
      qty: "Charge 2",
      rate: "Description for charge 2",
      amount: "Description for charge 2",
    },
  ],

  name: "Manage Order",
};

export const OfficerOrdersData = {
  columns: [
    { id: "requestid", label: "Request ID", width: 70 },
    { id: "orderid", label: "Order ID", width: 130 },
    { id: "table", label: "Table", width: 200 },
  ],
  rows: [
    {
      id: 1,
      requestid: "Charge 1",
      orderid: "Description for charge 1",
      table: "Description for charge 2",
    },
    {
      id: 2,
      requestid: "Charge 2",
      orderid: "Description for charge 2",
      table: "Description for charge 2",
    },
  ],

  name: "Orders",
};

export const Ordercanceldata = {
  columns: [
    { id: "id", label: "ID", width: 70 },
    { id: "name", label: "Name", width: 130 },
    { id: "catergory", label: "catergory", width: 200 },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Order cancel",
};

export const Addonsdata = {
  columns: [
    { id: "ADDONTYPE", label: "ADDON TYPE", width: 70 },
    { id: "DESCRIP", label: "DESCRIPtion", width: 130 },
    { id: "RATE", label: "RATE", width: 200 },
  ],

  name: "Addons Details",
};

export const ordertrackingdata = {
  columns: [
    { id: "ORDERSTATUS", label: "TRACKING TYPE", width: 200 },
    { id: "ENUSER", label: "USER", width: 200 },
    { id: "SMSTEXT", label: "Send SMS", width: 200,discardformatting:true },
    { id: "STS", label: "Status", width: 200, textAlign: "center" },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Order Tracking Details",
};

export const RecipeItemdata = {
  columns: [{ id: "MENUNAME", label: "MENU NAME", width: 200 }],

  name: "Recipes",
};

export const InvCatergorydata = {
  columns: [
    { id: "CATNAME", label: "Category Name", width: 120 },
    { id: "COLORCODE", label: "Color Code", width: 200 },
    // Add more column definitions as needed
  ],
  name: "Category Details",
};

export const InvProductdata = {
  columns: [
    { id: "PRODUCTNAME", label: "Product Name", width: 150 },

    { id: "MINORDERLEVEL", label: "Minimum Order Level", width: 120 },

    { id: "IMMEASURINGUNIT", label: "Unit", width: 80 },
    // {  id: "ISTAXAPPLY", label: "Tax", width: 60 },
    // Add more fields as needed
  ],
  name: "Product Details",
};

export const InvSubCatergorydata = {
  columns: [
    { id: "SUBCATNAME", label: "Subcategory Name", width: 120 },
    // Add more column definitions as needed
  ],
  name: "Subcategory Details",
};

export const Tablesdata = {
  columns: [
    {
      id: "COLORCODE",
      label: "COLOR CODE",
      width: 200,
      textAlign: "center",
      backgroundColor: "COLORCODE",
    },
    // { id: "STS", label: "STATUS", width: 200, textAlign: "center" },
    { id: "TABLENAME", label: "TABLE NAME", width: 70, textAlign: "Left" },
    {
      id: "NOOFSEATS",
      label: "NO OF SEATS",
      width: 130,
      textAlign: "right",
      type: "number",
      sortArrowPosition: "right",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Table Details",
};

export const stockdata = {
  columns: [
    { id: "FULLNAME", label: "Supplier NAME", width: 200, textAlign: "left" },
    {
      id: "GROSSAMT",
      label: "GROSS Amount",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "NETTAMT",
      label: "NET Amount",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "TAXAMT",
      label: "TAX Amount",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "DISCOUNT",
      label: "DISCOUNT Amount",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "INVOICENO",
      label: "INVOICE No",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "INVOICEDATE",
      label: "INVOICE Date",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
    },
  ],

  name: "GRN Details",
};

export const stockdetaildata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 200, textAlign: "left" },
    {
      id: "RATE",
      label: "RATE",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "SELLINGRATE",
      label: "SELLINg GRATE",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "QTY",
      label: "QTY",
      width: 70,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "TAXAMT",
      label: "TAX AMT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "DISCOUNT",
      label: "DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "Stock Details",
};

export const Menumealdata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70, textAlign: "left" },
    {
      id: "ITEMRATE",
      label: "ITEM RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "MEASURINGUNIT",
      label: "MEASURING UNIT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
      disableSort: true,
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Menu/Meal Details",
};

export const Promotiondata = {
  columns: [
    { id: "MENUNAME", label: "MENU NAME", width: 70 },
    {
      id: "PROMOCODE",
      label: "PROMO CODE",
      width: 130,
      textAlign: "center",
      flexDirection: "row-reverse",
    },
    {
      id: "RATE",
      label: "RATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "FROMDATE",
      label: "FROM DATE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Promotion Details",
};

export const Membershipdata = {
  columns: [
    { id: "GROUPNAME", label: "MEMBERSHIP NAME", width: 70 },
    {
      id: "DISCOUNT",
      label: "DISCOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "AMOUNTFORPOINTS",
      label: "AMOUNT FOR POINTS",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "POINTSFORAMOUNT",
      label: "POINTS FOR AMOUNT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },

    {
      id: "AMOUNTTOPOINTS",
      label: "AMOUNT TO POINTS",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "POINTSTOAMOUNT",
      label: "POINTS TO AMOUNT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Membership Details",
};

export const Suppilerdata = {
  columns: [
    { id: "FIRSTNAME", label: "FIRST NAME", width: 70 },
    {
      id: "EMAIL",
      label: "EMAIL",
      width: 130,
      textAlign: "left",
    },
    {
      id: "CONTACTNO",
      label: "CONTACT NO",
      width: 200,
      textAlign: "center",
    },
    {
      id: "CREDITLIMIT",
      label: "CREDIT LIMIT",
      width: 200,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    // { id: 'SUPREFCODE', label: 'SUPREF CODE', width: 200,textAlign: "right",flexDirection: 'row-reverse' },
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
  ],

  name: "Supplier Details",
};

export const Customerdata = {
  columns: [
    { id: "FIRSTNAME", label: "FIRST NAME", width: 130 },
    { id: "LASTNAME", label: "LAST NAME", width: 200 },
    { id: "EMAIL", label: "EMAIL", width: 200 },
    { id: "CONTACTNO", label: "CONTACT NO", width: 200, textAlign: "center" },
    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "Customer Details",
};

export const Giftcertificatedata = {
  columns: [
    { id: "GIFTNAME", label: "CERTIFICATE NAME", width: 70 },
    {
      id: "AMOUNT",
      label: "AMOUNT",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
    {
      id: "EXPIRYDATE",
      label: "EXPIRY DATE",
      width: 200,
      textAlign: "center",
      flexDirection: "row-reverse",
    },
  ],

  name: "Gift Certificate",
};

export const Giftvoucherdata = {
  columns: [
    { id: "VOUCHERNO", label: "VOUCHER NO", width: 70 },
    {
      id: "BARCODE",
      label: "BARCODE",
      width: 130,
      textAlign: "right",
      flexDirection: "row-reverse",
    },
  ],

  name: "Gift Voucher",
};

export const Mapuserdata = {
  columns: [
    {
      id: "USERNAME",
      label: "User Name",
      width: 130,
      textAlign: "left",
    },
    {
      id: "GROUPNAME",
      label: "Group Name",
      width: 200,
      textAlign: "left",
    },
    {
      id: "STARTDATE",
      label: "Start Date",
      width: 200,
      textAlign: "center",
    },
  ],

  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: " Map User Details",
};

export const usergroupdata = {
  columns: [
    { id: "GROUPNAME", label: "GROUP NAME", width: 130, textAlign: "left" },

    // Add more column definitions as needed
  ],
  rows: [
    { id: 1, name: "Charge 1", catergory: "Description for charge 1" },
    { id: 2, name: "Charge 2", catergory: "Description for charge 2" },
    // Add more rows as needed
  ],

  name: "User Group Details",
};

export const Measuringdata = {
  columns: [
    { id: "MEASURINGUNITNAME", label: "MEASURING UNIT NAME", width: 70, textAlign: "left" },
    // { id: "MENUTYPECODE", label: "MENUTYPECODE", width: 200, textAlign: "left" },

    { id: "MEASURINGUNIT", label: "MEASURING UNIT", width: 200, textAlign: "left",},
  ],

  name: "Measuring Units",
};